import { fabric } from 'fabric'
import { CIRCLE, RECTANGLE, LINE, TEXT, FILL, STROKE } from '../helpers/defaultShapes'
import { useEffect, useState } from 'react'


/**
 * Creates editor
 */

const buildEditor = (
  canvas,
  fillColor,
  strokeColor,
  _setFillColor,
  _setStrokeColor,
  scaleStep
) => {
  
  return {
    canvas,
    addCircle: () => {
      let centerPosition = canvas.getCenter()
      const object = new fabric.Circle({
        ...CIRCLE,
        fill: fillColor,
        ...centerPosition,
        stroke: strokeColor
      })
      canvas.add(object)
    },
    addRectangle: () => {
      let centerPosition = canvas.getCenter()
      const object = new fabric.Rect({
        ...RECTANGLE,
        ...centerPosition,
        fill: fillColor,
        stroke: strokeColor
      })
      canvas.add(object)
    },
    addLine: () => {
      let centerPosition = canvas.getCenter()
      const object = new fabric.Line(LINE.points, {
        ...LINE.options,
        ...centerPosition,
        stroke: strokeColor
      })
      canvas.add(object)
    },
    addImage: (image) => {
      let centerPosition = canvas.getCenter()
      const imageFile = new Image()
      imageFile.src = image
      fabric.Image.fromURL(image, (img) => {
        img.set({
          ...centerPosition,
          width: imageFile.width,
          height: imageFile.height,
          crossOrigin: 'anonymous'
        })
        canvas.add(img)
      })
    },
    addText: (text, settings) => {
      // use stroke in text fill, fill default is most of the time transparent
      let centerPosition = canvas.getCenter()
      const object = new fabric.Textbox(text, { ...TEXT, ...centerPosition, ...settings })
      object.set({ text: text })
      canvas.add(object)
    },
    updateText: (text, settings) => {
      const objects = canvas.getActiveObjects()
      if (objects.length && objects[0].type === TEXT.type) {
        const textObject = objects[0]
        textObject.set({ text, ...settings })
        canvas.renderAll()
      }
    },
    selectedCanvasObjects: (id) => {
      let items = canvas.getObjects()
      canvas.setActiveObject(items[id])
      canvas.renderAll();
    },
    deleteAll: () => {
      canvas.getObjects().forEach((object) => canvas.remove(object))
      canvas.discardActiveObject()
      canvas.renderAll()
    },
    deleteSelected: () => {
      canvas.getActiveObjects().forEach((object) => canvas.remove(object))
      canvas.discardActiveObject()
      canvas.renderAll()
    },
    fillColor,
    strokeColor,
    setFillColor: (fill) => {
      _setFillColor(fill)
      canvas.getActiveObjects().forEach((object) => object.set({ fill }))
      canvas.renderAll()
    },
    setStrokeColor: (stroke) => {
      _setStrokeColor(stroke)
      canvas.getActiveObjects().forEach((object) => {
        if (object.type === TEXT.type) {
          // use stroke in text fill
          object.set({ fill: stroke })
          return
        }
        object.set({ stroke })
      })
      canvas.renderAll()
    },
    zoomIn: () => {
      const zoom = canvas.getZoom()
      canvas.setZoom(zoom / scaleStep)
    },
    zoomOut: () => {
      const zoom = canvas.getZoom()
      canvas.setZoom(zoom * scaleStep)
    },
    getAllObjects: () => {
      let objectList = canvas.toJSON();

      return objectList.objects
    },
    canvasPosition: () => {
      let centerPosition = canvas.getCenter()
      let left = 20;
      let top = 20;
      let right = canvas.width - 20;
      let bottom = canvas.height - 20;
      let centerX = centerPosition.left;
      let centerY = centerPosition.top;

      return {
        left,
        top,
        right,
        bottom,
        centerX,
        centerY
      }
    },
    downloadCanvas: () => {
      console.log(canvas)
      let dataURL = canvas.toDataURL({
        format: 'png',
        quality: 1
      })
      console.log(dataURL)
      let link = document.createElement('a')
      link.href = dataURL
      link.download = 'canvas.png'
      link.click()
    }
  }
}

const useFabricJSEditor = (
  props = {}
) => {
  const scaleStep = props.scaleStep || 0.5
  const { defaultFillColor, defaultStrokeColor } = props
  const [canvas, setCanvas] = useState(null)
  const [fillColor, setFillColor] = useState(defaultFillColor || FILL)
  const [strokeColor, setStrokeColor] = useState(
    defaultStrokeColor || STROKE
  )
  const [selectedObjects, setSelectedObject] = useState([])
  useEffect(() => {
    const bindEvents = (canvas= fabric.Canvas) => {
      canvas.on('selection:cleared', () => {
        setSelectedObject([])
      })
      canvas.on('selection:created', (e) => {
        setSelectedObject(e.selected)
      })
      canvas.on('selection:updated', (e) => {
        setSelectedObject(e.selected)
      })
    }
    if (canvas) {
      bindEvents(canvas)
    }
  }, [canvas])

  return {
    selectedObjects,
    setSelectedObject,
    onReady: (canvasReady= fabric.Canvas) => {
      setCanvas(canvasReady)
    },
    selectObject: (object) => {
      canvas.setActiveObject(object)
      setSelectedObject([object])
    },
    download: () => {
      const dataURL = canvas.toDataURL({
        format: 'png',
        quality: 1,
        multiplier: 1
      })
      const link = document.createElement('a')
      link.href = dataURL
      link.download = 'canvas.png'
      link.click()
    },
    editor: canvas
      ? buildEditor(
          canvas,
          fillColor,
          strokeColor,
          setFillColor,
          setStrokeColor,
          scaleStep
        )
      : undefined
  }
}

export { buildEditor, useFabricJSEditor }